import * as React from 'react';
import { Card, Input, Tabs, Spin, notification } from 'antd';
import Flag from "react-flags";
import { AreaChartOutlined, UserOutlined } from '@ant-design/icons';
import gamesList from '../../components/ChooseGame/gamesList';
import { saveProfileName } from './api';
import { ProfileBox, ProfileNameBox } from './Profile.css';
import UserContext from '../../../contexts/UserContext';
import VisualMemoryScores from './Scores/VisualMemory/VisualMemoryScores';
import AimScores from './Scores/AimScores/AimScores';
import ReactionScores from './Scores/ReactionScores/ReactionScores';

const { Search } = Input;
const { TabPane } = Tabs;

const Profile = () => {
    const {user: userData, setUser: setUserData} = React.useContext(UserContext);
    const [savingUserName, setSavingUserName] = React.useState(false);
    const [localUserName, setLocalUserName] = React.useState('');

    React.useEffect(() => {
        setLocalUserName(userData.name);
    }, []);

    const renderProfileHeader = () => {
        return <div>
            <UserOutlined size={30} /> Your Profile
        </div>
    }

    if (userData.id === 0) {
        return (
            <ProfileBox>
                <Card bordered title={renderProfileHeader()} style={{ margin: "16px 16px" }}>
                    <Spin />
                </Card>
            </ProfileBox>
        )
    }

    const handleSaveUsername = async (value: string) => {
        if (userData.name === value || value === '') return;
        setSavingUserName(true);
        const saved = await saveProfileName(userData.id, value);
        if (saved.success) {
            showMessage('Username saved!', '');
            setUserData({...userData, name: value});
        }
        setSavingUserName(false);
    };

    const handleChangeLocalUserName: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        setLocalUserName(event.target.value);
    };

    const renderYourScoresHeader = () => {
        return <div>
            <AreaChartOutlined size={30} /> Your Scores
        </div>
    };

    const showMessage = (title: string, message: string) => {
        notification.open({
            message: title,
            description: message,
            onClick: () => {
            console.log('Notification Clicked!');
            },
        });
    };

    const renderScores = (id: string, gameId: number) => {
        switch(id) {
            case 'vm':
                return <VisualMemoryScores gameId={gameId} />
                break;
            case 'at':
                return <AimScores gameId={gameId} />
                break;
            case 'rt':
                return <ReactionScores gameId={gameId} />
            default:
                return <VisualMemoryScores gameId={gameId} />
                break;
        }
    };

    return (
        <ProfileBox>
            <Card bordered title={renderProfileHeader()} style={{ margin: "16px 16px", display: 'flex', flexDirection: 'column', flex: 1 }}>
                <ProfileNameBox>
                    <Search size="large" prefix={<Flag name={userData.country} shiny={true} basePath="img/" format="png" pngSize={24} />} placeholder="Player Name" onChange={handleChangeLocalUserName} value={localUserName} enterButton="Save" allowClear loading={savingUserName} onSearch={handleSaveUsername} />
                </ProfileNameBox>
                <Card title={renderYourScoresHeader()} style={{ marginTop: 10, padding: 0, display: 'flex', flexDirection: 'column', flex: 1, height: '100%', overflow: 'hidden' }}>
                    <Tabs style={{display: 'flex', height: '100%'}} tabPosition="left">
                        {gamesList.map((game, index) =>
                            <TabPane tab={game.name} key={index}>
                                {renderScores(game.id, game.gameId)}
                            </TabPane>
                        )}
                    </Tabs>
                </Card>
            </Card>
        </ProfileBox>
    );
};

export default Profile;